<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-07-15 18:22:41
 * @Description: file content
 rule rank prize
 规则、排行、奖品
 -->
<template>
  <div :class="['mymodal', `modal-${$setting.name}`, { animate: value && message.animate }]" :style="{ backgroundColor: message.bgColor }" v-show="value">
    <div class="info" :style="{ transform: this.message.animate ? 'scale(0)' : 'none' }">
      <!-- <img class="form-title" src="http://assets.rurushishi.com/activies/hhjx-purchase/form1.png" /> -->
      <img class="modalTitle" :src="configInfo.popupStyleImg" />
      <!-- <template v-if="!message.nextInfo">
        <div class="msg-info">
          <div class="msgTitle">很遗憾！</div>
          <div class="msg1">
            <div class="tip1" v-html="text"></div>
          </div>

          <div
            class="submit act-text-stroke"
            :style="{
              backgroundColor: configInfo.buttonBackgroundColour,
              color: configInfo.buttonTextColour,
            }"
            @click="value = false"
          >
            确认
          </div>
        </div></template
      >
      <template v-else>
        <div class="msg-info">
          <div class="msgTitle">恭喜你！</div>
          <div class="msg1">
            <div class="tip1" v-html="text"></div>
          </div>

          <div class="btnBox" v-if="requireLevel">
            <div
              class="btn act-text-stroke"
              :style="{
                backgroundColor: configInfo.buttonBackgroundColour,
                color: configInfo.buttonTextColour,
              }"
              @click="clickReceive"
            >
              领取礼品
            </div>
            <div
              class="btn act-text-stroke"
              :style="{
                backgroundColor: configInfo.buttonBackgroundColour,
                color: configInfo.buttonTextColour,
              }"
              @click="clickBottomBtnConfirm"
            >
              冲击大奖
            </div>
          </div>
          <div
            v-else
            class="submit act-text-stroke"
            :style="{
              backgroundColor: configInfo.buttonBackgroundColour,
              color: configInfo.buttonTextColour,
            }"
            @click="clickBottomBtnConfirm"
          >
            呼朋唤友
          </div>
        </div>
      </template> -->
      <template>
        <div class="msg-info">
          <div class="msgTitle">
            {{ message.title }}
          </div>
          <div class="msg1">
            <div class="tip1" v-html="message.text"></div>
          </div>
          <div
            class="submit act-text-stroke"
            :style="{
              backgroundColor: configInfo.buttonBackgroundColour,
              color: configInfo.buttonTextColour,
            }"
            @click="clickBottomBtnConfirm"
          >
            呼朋唤友
          </div>
        </div>
      </template>

      <img class="close" @click="clickClose" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";

export default {
  components: {},
  props: {},
  data() {
    return {
      value: false,
      callback: null,
      message: "",
      configInfo: {},
      requireLevel: true,
      text: "",
    };
  },
  watch: {
    value: function (newVal) {
      if (newVal) {
      }
    },
    message: function (newVal, oldval) {
      console.log(newVal, oldval);
    },
  },
  computed: {},
  mounted() {
    this.configInfo =this.$configInfo ;
  },
  methods: {
    //取消领奖
    clickClose() {
      this.value = false;
      this.callback("cancel");
    },
    clickBottomBtnConfirm() {
      this.value = false;
      if (this.configInfo.shareSwitch == 1) {
        let text = {
          text1: "邀请好友",
          text2: "还有更多惊喜",
          text3: "",
        };
        this.$modal.share.alert(text).then((data) => {
          if (data == "save") {
            console.log(this.configInfo.shareImg);
            this.$modal.poster.alert({
              gameBg: this.configInfo.shareImg, //分享截图背景图
            });
          }
        });
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@keyframes modal_animate {
  0 {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  &.animate {
    .info {
      animation-name: modal_animate;
    }
  }

  .info {
    position: relative;
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    animation-timing-function: ease-out;
    animation-duration: 1s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    transform: scale(0);

    .modalTitle {
      position: relative;
      width: 300px;
      z-index: 1;
    }

    .msg-info {
      position: relative;
      z-index: 0;
      margin-top: -1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 0px 0px 16px 16px;
      width: 100%;
      box-sizing: border-box;
      padding-bottom: 24px;
      background-color: #fff;

      .msgTitle {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #262626;
        margin-top: 10px;
      }

      .msg1 {
        .test1 {
          font-weight: 600;
          font-size: 18px;
        }

        font-size: 14px;
        line-height: 20px;
        margin-top: 12px;
        color: #595959;
        width: 240px;
        margin-bottom: 12px;
      }

      .btnBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 264px;

        .btn {
          width: 120px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          font-size: 20px;
          border-radius: 24px;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
          font-weight: 600;
          &.btn-prize{
            border: 1px solid;
            font-weight: normal;
          }
        }
      }

      .submit {
        margin-top: 12px;
        width: 220px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        border-radius: 24px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        font-weight: 600;
      }
    }

    .close {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1002;
      margin-top: 28px;
    }
  }
}
</style>
